import {
  MdBookmark,
  MdBookmarkBorder,
  MdContentCopy,
  MdDeleteOutline,
  MdOutlineAddLink,
  MdOutlineFileDownload,
  MdOutlineLink,
  MdOutlineModeEditOutline,
  MdOutlineVisibility,
} from 'react-icons/md';
import styled, { css } from 'styled-components';

import {
  BaseDropdownItem,
  BaseTriggerDropdown,
  Button,
} from '@gbs-monorepo-packages/common';
import { colors, radii } from '@gbs-monorepo-packages/styles';

interface DropdownItemsProps {
  $view: 'desktop' | 'mobile' | 'grid';
}

export const ActionButton = styled.button`
  all: unset;
  align-items: center;
  border-radius: ${radii.full};
  color: ${colors.blue400};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  height: 2.5rem;
  justify-content: center;
  margin: 0.25rem;
  width: 2.5rem;

  &:hover {
    background-color: ${colors.white300};
    filter: brightness(0.9);
  }
`;

export const ActionsButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-evenly;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const AllDropdownItemsContainer = styled.div<DropdownItemsProps>`
  display: block;

  @media screen and (min-width: 1000px) {
    display: ${({ $view }) => ($view === 'grid' ? 'block' : 'none')};
  }
`;

export const LastDropdownItems = styled.div<DropdownItemsProps>`
  display: block;

  @media screen and (max-width: 1000px) {
    display: ${({ $view }) =>
      $view === 'grid' || $view === 'mobile' ? 'block' : 'none'};
  }
`;

export const DropdownActionItem = styled(BaseDropdownItem)`
  font-size: 1rem;
  font-weight: 400;

  border-radius: ${radii.md};
  color: ${colors.labelText};
  cursor: pointer;
  height: 1.5rem;
  line-height: 1.125rem;
  padding: 4px;
  position: relative;
  user-select: none;

  &[data-highlighted] {
    background-color: ${colors.backgroundHover};
    outline: none;
  }
`;

export const DropdownButtonContainer = styled.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  width: 100%;
  justify-content: flex-end;
`;

export const MainButtonCustom = styled(Button)`
  border-radius: ${radii.full};
  color: ${colors.button};
  padding: 0.25rem;

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.25;
  }
`;

export const TriggerDropdownAction = styled(BaseTriggerDropdown)`
  background-color: ${colors.white300};
  color: ${colors.button};

  &:hover {
    background-color: ${colors.white300};
    filter: brightness(0.9);
  }
`;

export const iconStyles = css`
  height: 1.75rem;
  width: 1.75rem;
`;

export const AddLinkIcon = styled(MdOutlineAddLink)`
  ${iconStyles}
`;

export const DeleteIcon = styled(MdDeleteOutline)`
  ${iconStyles}
`;

export const DownloadIcon = styled(MdOutlineFileDownload)`
  ${iconStyles}
`;

export const DuplicateIcon = styled(MdContentCopy)`
  ${iconStyles}
`;

export const EditIcon = styled(MdOutlineModeEditOutline)`
  ${iconStyles}
`;

export const LinkIcon = styled(MdOutlineLink)`
  ${iconStyles}
`;

export const PreviewIcon = styled(MdOutlineVisibility)`
  ${iconStyles}
`;

export const BookmarkIcon = styled(MdBookmark)`
  ${iconStyles}
`;

export const BookmarkBorderIcon = styled(MdBookmarkBorder)`
  ${iconStyles}
`;
